import { createSelector, createSlice, PayloadAction } from "@reduxjs/toolkit";

import { SliceKeys, tablePaginationInitialValue } from "@sso/constant";
import { RootState } from "@sso/store";
import { SearchColumn } from "@sso/types";
import { getTableSortColumn, queryBuilder } from "@sso/utils";

export const BilledOperationSlice = createSlice({
    name: SliceKeys.BILLED_OPERATION,
    initialState: { openBilledOperationTable: false, pagination: tablePaginationInitialValue },
    reducers: {
         setBilledOperationSummariesPageSize: (state, action: PayloadAction<number>) => {
           state.pagination.pageIndex = tablePaginationInitialValue.pageIndex;
           state.pagination.pageSize = action.payload;
         },
         setBilledOperationSummariesPageIndex: (state, action: PayloadAction<number>) => {
           state.pagination.pageIndex = action.payload;
         },
         setBilledOperationSummariesSearchColumn: (state, action: PayloadAction<SearchColumn>) => {
           state.pagination.pageIndex = tablePaginationInitialValue.pageIndex;
           state.pagination.search[action.payload.column] = action.payload;
         },
         clearBilledOperationSummariesSearchColumn: (state, action: PayloadAction<string>) => {
           const { [action.payload]: deleteItem, ...otherSearchItems } = state.pagination.search;
           state.pagination.search = otherSearchItems;
         },
         setBilledOperationSummariesSortColumn: (state, action: PayloadAction<string>) => {
           const { column, type } = state.pagination.sort;
           state.pagination.sort = getTableSortColumn(column, action.payload, type);
           state.pagination.pageIndex = tablePaginationInitialValue.pageIndex;
         },   
    }
});

export const {
  setBilledOperationSummariesPageSize,
  setBilledOperationSummariesPageIndex,
  setBilledOperationSummariesSortColumn,
  setBilledOperationSummariesSearchColumn,
  clearBilledOperationSummariesSearchColumn
} = BilledOperationSlice.actions;

export const selectBilledOperationSummariesPagination = createSelector(
    (state: RootState) => state.billedOperation.pagination,
    ({ pageSize, totalPages, pageIndex, sort, search }) => ({
      pageSize: { action: setBilledOperationSummariesPageSize, value: pageSize },
      pagination: {
        totalPages,
        pageIndex,
        action: setBilledOperationSummariesPageIndex,
      },
      sort,
      search: { object: search, onChange: setBilledOperationSummariesSearchColumn, onClear: clearBilledOperationSummariesSearchColumn },
    }),
  );

export const selectBilledOperationSummariesQuery = createSelector(
  (state: RootState) => state.billedOperation.pagination,
  ({ pageSize, pageIndex, search, sort }) => queryBuilder(pageSize, pageIndex, search, sort),
);

export default BilledOperationSlice.reducer;